import Alpine from "alpinejs";
import Swal from "sweetalert2/dist/sweetalert2";

window.sessionCookieStorage = {
    getItem(key) {
        const cookies = document.cookie.split(";");

        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].split("=");
            if (key == cookie[0].trim()) {
                return decodeURIComponent(cookie[1]);
            }
        }

        return null;
    },
    setItem(key, value) {
        document.cookie = `${key}=${encodeURIComponent(value)}; path=/; SameSite=Lax`;
    },
};

Alpine.store("compareItems", {
    maxItems: 3,
    data: Alpine.$persist({ type: null, items: [] }).as("compareItems").using(window.sessionCookieStorage),

    get items() {
        return this.data.items;
    },

    get type() {
        return this.data.type;
    },

    /**
     * Adds an item to the list.
     * @param item
     * @returns {boolean}
     * @throws Error Throws an error if max items reached / adding mismatched types. Codes: `MaxItemsReached`, `MismatchedTypes`
     */
    add(item) {
        if (this.data.items.length && this.data.type && this.data.type !== item.type) {
            throw new Error("You cannot compare both Plans and Inventory Homes.", {
                cause: {
                    code: "MismatchedTypes",
                },
            });
        }

        if (this.items.length === this.maxItems) {
            throw new Error(`You can only compare up to ${this.maxItems} items.`, {
                cause: {
                    code: "MaxItemsReached",
                },
            });
        }

        window.dataLayer.push({
            "event": "comparison_toggle",
            "comparison_data": {
                "id": item.id,
                "type": item.type,
                "name": item.name,
            },
        });

        this.data.type = item.type;
        this.data.items = [...this.data.items, item];

        return true;
    },

    remove(item) {
        this.data.items = this.data.items.filter((savedItem) => savedItem.id !== item.id);

        return true;
    },

    exists(item) {
        return !!this.items.filter((savedItem) => savedItem.id === item.id && savedItem.type === item.type).length;
    },

    /**
     * Toggles the item by adding / removing from the list depending on its current state.
     *
     * @param {Object} item
     * @returns {boolean} Returns true if toggle was successful
     */
    toggle(item) {
        if (this.exists(item)) {
            return this.remove(item);
        }

        return this.add(item);
    },

    clear() {
        this.data.type = null;
        this.data.items = [];
    },
});

Alpine.data("compareToggle", () => ({
    item: {
        type: null,
        id: null,
        name: null,
        image: null,
    },
    timeoutId: null,

    init() {
        queueMicrotask(() => {
            const { type, id, name, image } = this.$el.dataset;

            this.item = {
                type,
                id: Number(id),
                name,
                image,
            };
        });
    },

    toggle: {
        ["@click"]() {
            try {
                this.$store.compareItems.toggle(this.item);

                // Trying to fix the issue where the checkbox is not checked when selected from within a slider.
                window.setTimeout(() => {
                    this.$el.checked = this.$store.compareItems.exists(this.item);
                }, 100);

            } catch (error) {
                // Un-check since there was an error.
                if (["MaxItemsReached", "MismatchedTypes"].includes(error.cause?.code)) {
                    this.$el.checked = false;

                    const swalOptions = {
                        title: "Sorry",
                        text: error.message,
                        icon: "warning",
                    };

                    if (error.cause.code === "MismatchedTypes") {
                        Swal.fire({
                            ...swalOptions,
                            showCancelButton: true,
                            confirmButtonText: "Replace selections and continue",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.$store.compareItems.clear();

                                this.$store.compareItems.add(this.item);
                            }
                        });

                        return;
                    }

                    Swal.fire(swalOptions);
                }
            }
        },
        [":checked"]() {
            return this.$store.compareItems.exists(this.item);
        },
    },
}));
